import { useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";

const NotificationsCommandBar = ({ handleClearNotification }) => {
  const { pathname } = useLocation();

  const isButtonVisible = useMemo(() => pathname.includes("new"), [pathname]);

  return (
    <div className="notifications-command-bar command-bar-container">
      <h1 className="title">Notifications</h1>

      <div className="right-column-wrapper">
        {isButtonVisible && (
          <button
            className="tab-button"
            onClick={() => handleClearNotification(null)}
          >
            Mark all as read
          </button>
        )}
        <button className="tab-button">
          <NavLink to="/notifications/new" className="notification-link">
            New
          </NavLink>
        </button>
        <button className="tab-button">
          <NavLink to="/notifications/cleared" className="notification-link">
            Cleared
          </NavLink>
        </button>
      </div>
    </div>
  );
};

export default NotificationsCommandBar;
